/**
 * Z-слои FX онлайн-белота (Candywings-стиль). Числа — для `style.zIndex` / arbitrary Tailwind.
 */

/**
 * Слой позиций мест (аватары, капли торгов/комбо, речь бела).
 * Выше взятки (z≈19–22), ниже комбо-ревила ({@link BELOT_FX_Z_COMBO_FAN}) и критических оверлеев.
 */
export const BELOT_FX_Z_TABLE = 36;

/** Зарезервировано под будущее разделение «сукно vs места» */
export const BELOT_FX_Z_AVATAR = 20;

/** Action bubbles: торги, пас (внутри колонки места) */
export const BELOT_FX_Z_ACTION_BUBBLE = 25;

/** Речевые бабблы: Блот / Реблот */
export const BELOT_FX_Z_SPEECH_BUBBLE = 30;

/** Веер объявлений после 1-й взятки */
export const BELOT_FX_Z_COMBO_FAN = 40;

/** Шулер X-Ray, оверлеи конца раунда */
export const BELOT_FX_Z_CRITICAL_OVERLAY = 50;

/** Редкие эмодзи в FX (шулер 🐭 и т.п.) — выключено по умолчанию */
export const BELOT_FX_FUN_EMOJI = false;
